import {ContainerIcon, PackageIcon, PlayIcon} from '@primer/octicons-react'
import {SkeletonText} from '@primer/react/experimental'
import {useClickAnalytics} from '@github-ui/use-analytics'
import type {SidebarPackagesProps} from '../types'
import {SidebarSection} from './SidebarSection'
import {SidebarLink} from './SidebarLink'
import {SidebarListItem} from './SidebarListItem'
import styles from './SidebarPackages.module.css'

function getPackageIcon(packageType: string) {
  if (packageType === 'container') return <ContainerIcon />
  if (packageType === 'actions') return <PlayIcon />
  return <PackageIcon />
}

/** Renders the Packages section of the repository sidebar. */
export function SidebarPackages({packageCount, packages, packagesPath, canWrite, publishPath}: SidebarPackagesProps) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  const moreCount = packageCount - packages.length

  return (
    <SidebarSection
      title="Packages"
      href={packagesPath}
      count={packageCount}
      moreCount={moreCount > 1 ? moreCount : undefined}
      moreLabel="packages"
    >
      {packages.length > 0 ? (
        <ul className={styles.packageList}>
          {packages.map(pkg => (
            <SidebarListItem
              key={`pkg-${pkg.name}`}
              className={styles.packageItem}
              icon={getPackageIcon(pkg.packageType)}
              label={pkg.name}
              href={pkg.path}
              onClick={() =>
                sendClickAnalyticsEvent({
                  category: 'REPOSITORY_OVERVIEW',
                  action: 'click',
                  label: 'location:sidebar;section:packages',
                })
              }
            />
          ))}
        </ul>
      ) : (
        <div className={styles.emptyState}>
          <span>No packages published</span>
          {canWrite && publishPath && (
            <>
              <br />
              <SidebarLink to={publishPath} inline>
                <span>Publish your first package</span>
              </SidebarLink>
            </>
          )}
        </div>
      )}
    </SidebarSection>
  )
}

export function SidebarPackagesSkeleton() {
  return (
    <SidebarSection title="Packages">
      <SkeletonText />
    </SidebarSection>
  )
}
